exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2cfXIhQW4zPaDxIdbj5M9x{font-size:.92857rem;line-height:1.15385;color:#a4a4a4;line-height:1.53846}._2cfXIhQW4zPaDxIdbj5M9x,.AJ7pUzf3nlopE6F6kBUZR{font-family:-apple-system,\\.SFNSText-Regular,BlinkMacSystemFont,San Francisco,Roboto,Segoe UI,Helvetica Neue,Lucida Grande,Microsoft YaHei,sans-serif;font-weight:400;letter-spacing:.03571rem}.AJ7pUzf3nlopE6F6kBUZR{font-size:1rem;line-height:1.07143;line-height:1.42857}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"UserInfo_date": "_2cfXIhQW4zPaDxIdbj5M9x",
	"UserInfo_name": "AJ7pUzf3nlopE6F6kBUZR"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanApprovalView/UserInfo/style.postcss
// module id = 2047
// module chunks = 0